export default __webpack_public_path__ + "static/media/a041-4.4666f910.png";